import type { ApplicationAgent as ApplicationAgentModel } from '@/adapters/catalogv1.g';

export function extractApplicationAgent(model: ApplicationAgentModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    applicationRef: model.application_ref ?? '',
    agentRef: model.agent_ref ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogApplicationAgent = ReturnType<
  typeof extractApplicationAgent
>;
